import React, { useEffect, useRef } from 'react'
import { drawBackgroundWithLayers, initCanvas } from 'utils/canvasUtils'
import { downloadMedia, loadImage } from 'utils/mediaUtils'

const PreventiveLayers = ({
  backgroundImageUrl,
  preventiveImages,
  position,
  displayedLayers,
  onLoad = () => {},
  className
}) => {
  const canvasRef = useRef()

  useEffect(() => {
    const drawPreventiveLayers = async () => {
      let canvas = canvasRef.current
      initCanvas({ canvas })

      const backgroundImage = await loadImage(backgroundImageUrl)

      const layersImages = (
        await Promise.all(
          displayedLayers.map(async layer => {
            try {
              const s3 = preventiveImages[position]?.[layer]
              if (!s3) return null
              const data = await downloadMedia(s3)
              return await loadImage(data)
            } catch (e) {
              return null
            }
          })
        )
      ).filter(Boolean)

      drawBackgroundWithLayers({
        canvas,
        backgroundImage,
        layersImages,
        onLoad
      })
    }

    drawPreventiveLayers()
  }, [backgroundImageUrl, displayedLayers, onLoad, position, preventiveImages])

  return <canvas id="preventive-layers-canvas" ref={canvasRef} className={className} />
}

export default React.memo(PreventiveLayers)
